import { render, staticRenderFns } from "./BRadioGroupWithValidation.vue?vue&type=template&id=08c7226e&scoped=true&"
import script from "./BRadioGroupWithValidation.vue?vue&type=script&lang=js&"
export * from "./BRadioGroupWithValidation.vue?vue&type=script&lang=js&"
import style0 from "./BRadioGroupWithValidation.vue?vue&type=style&index=0&id=08c7226e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c7226e",
  null
  
)

export default component.exports